<template>
  <ion-page class="cut-box">
    <common-background
      :title="'快闪魔方第' + step + '组'"
      router-type="modal"
      @router-back="onConfirmClose"
    >
      <template #default>
        <div v-show="!showButtons" class="cut-box_page">
          <div v-if="dataList?.length" class="word-list">
            <div
              v-for="(item, index) in dataList"
              :key="index"
              class="word-list_item flex-row justify-between"
              @click="onShowParaphrase(index, item, $event)"
            >
              <div class="item-word flex-row align-center flex-wrap">
                <span
                  v-show="!item.showParaphrase"
                  class="word-style switch-font-size flex-row align-center mr-5"
                >
                  {{ item.word }}
                </span>
                <div
                  v-show="item.showParaphrase"
                  class="cnword word-style gray-color flex-row flex-wrap"
                >
                  <span class="english-word switch-font-size">{{ item.word }}</span
                  ><span>{{ item.paraphrase }}</span>
                </div>
              </div>
              <div class="item-icon flex-row align-center">
                <img
                  v-if="item?.audioIconShow || (!showButtons && showOneButton)"
                  class="mr-4 img-icon cursor-pointer"
                  src="@/assets/teacher_index/version5/teacher_button.png"
                  @click.stop="
                    playUniversalFormulaAudio(item.word, item.paraphrase, 50 * speedRate)
                  "
                />
                <!--  :src="getBrandImageUrl('speed/cut_box_button.png')"-->
                <div v-if="showOneButton" @click.stop="onSelect2(index, item)">
                  <img
                    class="test-icon cursor-pointer"
                    src="@/assets/teacher_index/version5/scissors_right.svg"
                    alt=""
                  />
                </div>

                <div v-if="!showOneButton" @click.stop="onYes2(index, item)">
                  <img
                    class="test-icon mr-4 cursor-pointer"
                    src="@/assets/teacher_index/version5/scissors_right.svg"
                    alt=""
                  />
                </div>

                <div v-if="!showOneButton" @click.stop="onNot(index, item)">
                  <img
                    class="test-icon cursor-pointer"
                    src="@/assets/teacher_index/version5/scissors_mistake.svg"
                    alt=""
                  />
                </div>

                <!--                      两英一汉发音-->
                <!--                <img-->
                <!--                     v-if="!showButtons && showOneButton"-->
                <!--                    class="test-icon ml-4"-->
                <!--                    :src="getBrandImageUrl('speed/two_one.png')"-->
                <!--                    alt=""-->
                <!--                    @click.stop="playAudio(item)"-->
                <!--                />-->
              </div>
            </div>
          </div>
          <div v-else class="cut-box-empty">
            <!--              <div class="cut-box-empty-tip" :class="{'onlyNotNumClass': selectNotNum && !selectYesNum}">-->
            <!--                <div class="cut-box-empty-tip__title">点击继续</div>-->
            <!--                <img class="cut-box-empty-tip__img" :src="getBrandImageUrl('speed/green_down_icon.png')" alt="点击继续">-->
            <!--              </div>-->
            <!--              <div v-show="selectNotNum" class="cut-box-empty-tip notNumClass">-->
            <!--                <div class="cut-box-empty-tip__title">点击继续</div>-->
            <!--                <img class="cut-box-empty-tip__img" :src="getBrandImageUrl('speed/red_down_icon.png')" alt="点击继续">-->
            <!--              </div>-->
          </div>
        </div>
        <div
          v-show="showButtons"
          class="cut-box_page encourage-padding flex-column justify-between"
        >
          <div class="emoji flex-column align-center">
            <img :src="getBrandImageUrl('speed/encourage_bg.png')" alt="" />
          </div>
          <div class="flex-column">
            <ion-button class="button-outline mb-3" shape="round" @click="onReCheck"
              >重新检查
            </ion-button>
            <ion-button
              v-show="!isEnd && !needMixture"
              class="green_bg mb-3"
              shape="round"
              @click="backSign"
              >下一组
            </ion-button>
            <ion-button
              v-show="needMixture"
              class="green_bg mb-3"
              shape="round"
              @click="openMixture(step)"
              >混组检查
            </ion-button>
            <ion-button
              v-show="isEnd && !needMixture"
              class="green_bg mb-3"
              shape="round"
              @click="openMixture(10)"
              >全部混组
            </ion-button>
          </div>
        </div>
      </template>
      <template #rightTitle>
        <switch-font-size />
        <speed-switch :pause-show="true" :pause-flag="pauseFlag" @onPauseClass="onPauseClass" />
      </template>
    </common-background>
    <div v-show="!showButtons" class="cut-box_bottom">
      <div class="cut-box_bottom-content flex-row justify-evenly align-center">
        <div v-show="showOneButton" class="cut-box_box" @click="onRestore">
          <img
            v-show="selectNum === 0"
            src="@/assets/teacher_index/version5/empty_green_box.svg"
            alt=""
          />
          <img
            v-show="selectNum !== 0"
            src="@/assets/teacher_index/version5/fill_green_box.svg"
            alt=""
          />
          <span class="box-text true-text">{{ selectNum }}</span>
        </div>
        <div
          v-show="!showOneButton && selectYesNum === 0"
          class="cut-box_box"
          @click="onYesRestore"
        >
          <img src="@/assets/teacher_index/version5/empty_green_box.svg" alt="" />
          <span class="box-text true-text">{{ selectYesNum }}</span>
        </div>
        <div
          v-show="!showOneButton && selectYesNum !== 0"
          class="cut-box_box"
          @click="onYesRestore"
        >
          <img src="@/assets/teacher_index/version5/fill_green_box.svg" alt="" />
          <span class="box-text true-text">{{ selectYesNum }}</span>
        </div>
        <div
          v-show="!showOneButton && selectNotNum === 0"
          class="cut-box_box"
          @click="onNotRestore"
        >
          <img src="@/assets/teacher_index/version5/empty_red_box.svg" alt="" />
          <span class="box-text false-text">{{ selectNotNum }}</span>
        </div>
        <div
          v-show="!showOneButton && selectNotNum !== 0"
          class="cut-box_box"
          @click="onNotRestore"
        >
          <img src="@/assets/teacher_index/version5/fill_red_box.svg" alt="" />
          <span class="box-text common-red-color false-text">{{ selectNotNum }}</span>
        </div>
      </div>
    </div>
  </ion-page>
</template>

<script>
import { IonButton, IonPage, modalController } from "@ionic/vue"

import {
  arrowBackCircle,
  arrowForwardCircle,
  arrowUndo,
  checkmarkCircle,
  chevronBackOutline,
  closeCircle,
  gitCompare,
  pause,
  reorderFour,
} from "ionicons/icons"

import Mixture from "@/views/speed/Mixture"
import store from "@/js/store"
import { BRAND_IMAGES, getBrandImageUrl } from "@/js/brandImages.ts"
import CommonBackground from "@/components/CommonBackground.vue"
import { playUniversalFormulaAudio } from "@/js/commonMethod"
import SpeedSwitch from "@/components/speedSwitch.vue"
import { useStorage } from "@vueuse/core"
import SwitchFontSize from "@/views/other/SwitchFontSize.vue"

const speedRate = useStorage("xf-speed", 1, localStorage)
export default {
  name: "SpeedCutBox",
  components: {
    SwitchFontSize,
    SpeedSwitch,
    CommonBackground,
    IonPage,
    IonButton,
  },
  props: ["studentId", "step"],
  setup() {
    return {
      pause,
      checkmarkCircle,
      closeCircle,
      chevronBackOutline,
      gitCompare,
      arrowUndo,
      reorderFour,
      arrowBackCircle,
      arrowForwardCircle,
      speedRate,
    }
  },

  data() {
    return {
      dataList: [],
      showButtons: false, //剪纸盒步骤
      showOneButton: true, //混组检查第一步
      isEnd: false, //控制"混组全部"按钮显示
      isOver: false, //控制"全部结束"按钮显示
      selectItems: [],
      selectYesItems: [],
      selectNotItems: [],
      selectNum: 0,
      selectYesNum: 0,
      selectNotNum: 0,
      pauseFlag: false, //是否暂停过标记
      brandImages: BRAND_IMAGES,
    }
  },

  computed: {
    //计算当前步骤是否需要混组
    needMixture() {
      if (this.step == 1 || this.step == 4 || this.step == 7) {
        return false
      } else {
        return true
      }
    },
  },

  async mounted() {
    this.userinfo = this.store.getUser()
    this.queryVocabulary()
    this.getPauseStatus() //读取暂停状态
  },

  methods: {
    playUniversalFormulaAudio,
    getBrandImageUrl,
    routerBack() {
      modalController.dismiss()
    },

    backSign() {
      modalController.dismiss({ status: "TO_SIGN" })
    },

    //混组检查
    async openMixture(step) {
      //this.showButtons = false;
      const modal = await modalController.create({
        component: Mixture,
        componentProps: { studentId: this.studentId, step: step },
        cssClass: "modal_controller_class",
        backdropDismiss: false, // 禁止点击背景关闭
        keyboardClose: false, // 禁止ESC按键关闭
      })
      await modal.present()
      const { data } = await modal.onDidDismiss()
      console.log("cutbox1", data)
      if (data) {
        await modalController.dismiss({ ...data })
      }
    },

    //重新检查
    onReCheck() {
      if (this.selectYesItems.length > 0 && this.dataList.length == 0) {
        for (let i = 0; i < this.selectYesItems.length; i++) {
          this.selectYesItems[i]["audioIconShow"] = false
          this.dataList.push(this.selectYesItems[i])
        }
        this.showButtons = false //剪纸盒步骤
        this.selectItems = []
        this.selectYesItems = []
        this.selectNotItems = []
        this.selectNum = 0
        this.selectYesNum = 0
        this.selectNotNum = 0
      }
    },

    //点击中间盒子,释放单词
    onRestore() {
      if (this.selectItems.length > 0 && this.dataList.length == 0) {
        this.showOneButton = false
        for (let i = 0; i < this.selectItems.length; i++) {
          this.dataList.push(this.selectItems[i])
        }
        this.selectItems = []
        this.selectNum = 0
      }
    },

    //点击左边盒子,释放单词
    onYesRestore() {
      if (this.selectYesItems.length > 0) {
        this.dataList.push(this.selectYesItems.pop())
        this.selectYesNum = this.selectYesItems.length
      }
    },

    //点击右边盒子,释放单词
    onNotRestore() {
      if (this.selectNotItems.length > 0) {
        // this.dataList.push(this.selectNotItems.pop());
        // this.selectYesNum = this.selectNotItems.length;
        this.selectNotItems = this.selectNotItems.map((item) => {
          item["audioIconShow"] = true
          item["clickStep"] = 1
          return item
        })
        this.dataList = this.dataList.concat(this.selectNotItems)
        this.selectNotItems = []
        this.selectNotNum = this.selectNotItems.length
      }
    },

    //第一遍打钩
    onSelect(index, item) {
      if (item.showParaphrase) {
        item.showParaphrase = false
        this.selectItems.push(item)
        this.selectNum++
        this.dataList.splice(index, 1)
        this.audio(this.voice_path + "right.mp3")
      } else {
        item.showParaphrase = true
        //this.playSound(item.word);
        item["playbackRate"] = speedRate.value
        this.playSoundTemp(item)
      }
    },

    //自动带读模式，第一遍学习每个单词需要点击三次
    //第一遍打钩  重写，2024-02-27
    //点击3次，第一次只发音，第二次显示中英文，第三次消失
    onSelect2(index, item) {
      //第一遍只发音
      if (item.clickStep == 1) {
        item["playbackRate"] = speedRate.value
        this.playSoundTemp(item)
        item.showParaphrase = true
        item.clickStep = 3
      }

      //第三遍消失
      else if (item.clickStep == 3) {
        item.showParaphrase = false
        item.clickStep = 1
        this.selectItems.push(item)
        this.selectNum++
        this.dataList.splice(index, 1)
        this.audio(this.voice_path + "right.mp3")
      }
    },

    //第二遍打钩
    onYes(index, item) {
      item.showParaphrase = false
      item["audioIconShow"] = false
      this.selectYesItems.push(item)
      this.selectYesNum = this.selectYesItems.length
      this.dataList.splice(index, 1)
      this.audio(this.voice_path + "right.mp3")
      if (this.dataList.length == 0 && this.selectNotItems.length == 0) {
        this.showButtons = true //混组检查
      }
    },

    onYes2(index, item) {
      //第一遍只发音
      if (item.clickStep == 1) {
        // item["playbackRate"] = speedRate.value;
        // this.playSoundTemp(item);
        item.showParaphrase = false
        item.clickStep = 1
        item["audioIconShow"] = false
        this.selectYesItems.push(item)
        this.selectYesNum = this.selectYesItems.length
        this.dataList.splice(index, 1)
        this.audio(this.voice_path + "right.mp3")
        if (this.dataList.length == 0 && this.selectNotItems.length == 0) {
          this.showButtons = true //混组检查
        }
      }
    },

    //打叉
    onNot(index, item) {
      item.showParaphrase = false
      this.selectNotItems.push(item)
      this.selectNotNum = this.selectNotItems.length
      this.dataList.splice(index, 1)
      this.audio(this.voice_path + "err.mp3")
    },

    //点击单词,显示释义
    onShowParaphrase(index, item, playSW) {
      //this.playSound(item.word);

      if (playSW) {
        item["playbackRate"] = speedRate.value
        this.playSoundTemp(item)
      }

      for (let i = 0; i < this.dataList.length; i++) {
        if (index == i) {
          item["checked"] = true
          this.dataList[i].showParaphrase = !item.showParaphrase
        } else {
          item["checked"] = false
          this.dataList[i].showParaphrase = false
        }
      }
      console.log(item)
    },

    randomSort(list) {
      //仅对元素个数大于2个的数组进行打乱
      if (list.length < 2) {
        return
      }

      const list2 = list.slice(0)

      list.sort(function () {
        return 0.5 - Math.random()
      })

      let sameNum = 0
      for (let i = 0; i < list.length; i++) {
        if (list[i] == list2[i]) {
          sameNum++
        }
      }

      if (sameNum >= 2) {
        this.randomSort(list)
        console.log("重新打乱。。。")
      }
    },

    //查询需要练习的词汇
    queryVocabulary(ev) {
      this.ajax
        .post("/vocabulary/queryCurrentWords", {
          studentId: this.studentId,
          pageNum: this.step,
        })
        .then((res) => {
          const page = res.data.page
          const list = page.list
          if (page.isLastPage) {
            this.isEnd = true
          }

          if (list) {
            //打乱顺序
            this.randomSort(list)

            for (let i = 0; i < list.length; i++) {
              list[i].status = 1
              list[i].showParaphrase = false
              list[i].clickStep = 1 //自动带读，需要点击3次，分别对于不同处理逻辑
            }
            this.dataList = list
          }

          //关闭刷新等待动画
          if (ev) {
            ev.target.complete()
          }
        })
    },

    doRefresh(RefreshAnimationEvent) {
      this.tools.closeRefreshAnimation(RefreshAnimationEvent, 2000)
      this.queryVocabulary(RefreshAnimationEvent)

      //重置状态
      this.selectItems = []
      this.selectYesItems = []
      this.selectNotItems = []
      this.selectNum = 0
      this.selectYesNum = 0
      this.selectNotNum = 0
    },

    //点击暂停按钮
    onPauseClass() {
      const that = this
      const appointment = store.getAppointment()
      if (appointment == null) {
        that.alert("获取当前正在练习的资料信息失败。")
      } else {
        that.ajax.get("/record/pauseClass?aptmId=" + appointment.aptmId).then((res) => {
          if (res.data.success) {
            that.pauseFlag = true
            that.alert("本次训练暂停5分钟")
          }
        })
      }
    },

    //读取暂停状态
    getPauseStatus() {
      const that = this
      const appointment = store.getAppointment()
      if (appointment == null) {
        that.alert("获取当前正在练习的资料信息失败。")
      } else {
        that.ajax.get("/record/getPauseStatus?aptmId=" + appointment.aptmId).then((res) => {
          if (res.data.success) {
            if (res.data.data && res.data.data.pause == 1) {
              that.pauseFlag = true
            }
          }
        })
      }
    },
  },
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";
@import "@/styles/variables.less";

.cut-box {
  width: 100%;
  height: 100%;
  position: relative;
  user-select: none;
  -webkit-user-select: none;

  &_page {
    width: 100%;
    height: calc(100% - 7rem);
    overflow: auto;
    padding: 0.8rem;
    background-color: #ffffff;

    .word-list {
      &_item {
        padding: 4vw;
        background-color: var(--page-bg-color);
        border-radius: 0.3rem;
        margin-bottom: 5vw;
        border: 1px solid transparent;
        position: relative;

        .item-word {
          flex: 1;
          width: 70%;
        }

        .item-icon {
          min-width: 25%;
          flex-shrink: 0;
        }

        .english-word {
          margin-right: 1rem;
        }

        .left-line {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translate(0, -50%);
          width: 0.8vw;
          height: 60%;
          border-radius: 0.5vw;
          background-color: var(--green-bg-color);
        }

        .word-style {
          max-width: 100%;
          font-size: var(--font-size);
          word-break: break-all;
          align-items: baseline;
        }

        .test-icon {
          width: 2rem;
          height: 2rem;
          margin-top: 0.3rem;
          flex-shrink: 0;
          transition: transform 0.1s ease-in-out;

          &:active {
            transform: scaleY(0);
            transition: transform 0.1s ease-in-out;
          }
        }

        .img-icon {
          width: 2rem;
          margin-left: 3vw;
        }
      }

      .item-checked {
        border: 1px solid var(--green-bg-color);
      }
    }

    .statistic {
      color: var(--font-grey-color);
    }

    ion-button::part(native) {
      box-sizing: content-box;
      padding: 1vw 0;
    }
  }

  &-empty {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;

    &-tip {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-bottom: 8vh;

      &__title {
        color: #868f9e;
        font-size: 1rem;
        margin-bottom: 10px;
      }

      &__img {
        width: 25vw;
      }
    }

    .onlyNotNumClass {
      opacity: 0;
    }

    .notNumClass {
      margin-left: 10vw;
    }
  }

  .encourage-padding {
    width: 100%;
    height: 100%;
    padding: 0 5vw;

    .emoji {
      width: 90%;
      margin: 0 auto;
    }
  }

  &_bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 7rem;
    background-color: #ffffff;
    box-shadow: 1px 1px 2px 0 var(--font-grey-color);

    &-content {
      height: 80%;
      padding: 2vh 3vw 0;
    }
  }

  &_box {
    position: relative;
    //width: 8vh;

    img {
      width: 4rem;
    }

    .box-text {
      position: absolute;
      left: 50%;
      top: 16%;
      transform: translate(-50%, -50%);
      font-weight: 600;
    }

    .true-text {
      color: #0bbb7d;
    }

    .false-text {
      color: #ff3142;
    }
  }
}
</style>
